import { render } from "./ClientContextLayout.vue?vue&type=template&id=35fdf113&scoped=true"
import script from "./ClientContextLayout.vue?vue&type=script&lang=js"
export * from "./ClientContextLayout.vue?vue&type=script&lang=js"

import "./ClientContextLayout.vue?vue&type=style&index=0&id=35fdf113&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fdf113"]])

export default __exports__